import { useEffect } from 'react';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { getStationeryDispatchById } from 'src/redux/slices/stationery-dispatch';

import ErrorContent from 'src/components/error-content';
import { useSettingsContext } from 'src/components/settings';
import { LeftIcon } from 'src/components/carousel/arrow-icons';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';

import { LoadingScreen } from '../../../components/loading-screen';
import StationeryDispatchDetails from '../stationery-dispatch-details';
import { useAppDispatcher, useAppSelector } from '../../../redux/store';

type Props = {
  id: string;
};

export default function StationeryDispatchDetailView({ id }: Props) {
  const { dispatch: currentDispatch, status, error } = useAppSelector(
    (state) => state.stationeryDispatch
  );

  const settings = useSettingsContext();
  const dispatch = useAppDispatcher();

  useEffect(() => {
    dispatch(getStationeryDispatchById({ itemID: id }));
  }, [dispatch, id]);

  if (status === 'loading' || status === 'idle') {
    return <LoadingScreen />;
  }

  if (status === 'failure') {
    return (
      <ErrorContent
        filled
        title="Failed to load dispatch details"
        description={error}
        action={
          <Button
            component={RouterLink}
            href={paths.dashboard.stationeryDispatch.root}
            variant="contained"
            startIcon={<LeftIcon />}
          >
            Back to Dispatch
          </Button>
        }
        sx={{
          py: 10,
        }}
      />
    );
  }

  if (status === 'success' && currentDispatch) {
    return (
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Dispatch Details"
          links={[
            {
              name: 'Dispatch',
              href: paths.dashboard.stationeryDispatch.root,
            },
            { name: 'Dispatch Details' },
          ]}
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        />

        <StationeryDispatchDetails currentDispatch={currentDispatch} />
      </Container>
    );
  }

  return <span />;
}
